module.exports = __webpack_public_path__ + "img/pixel.6becaebe.png";